import { Formik } from "formik";
import { useReducer, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import FormDisplay from "./FormDisplay";
import pages from "../../../constants/pages";
import { useAxios, useAlert } from "../../../hooks";
import { objectFromFormData, schema } from "./audienceObjects";

export default function Form({
  fields,
  formData,
  component,
  editState,
  setEditState,
  setFields,
  segments,
  setFormData,
}) {
  const axios = useAxios();
  var intialValue = formData;
  var message = {};

  const { alert } = useAlert();
  const navigate = useNavigate();
  const dispatchUpdate = useDispatch();

  const memberDetails = useSelector((state) => state.memberDetails);

  const [activeIndexes, setActiveIndexes] = useState(
    formData?.activeIndexes || []
  );
  const [includedSegments, setIncludedSegments] = useState(
    formData?.includedSegments || []
  );
  const [state, dispatch] = useReducer(formReducer, intialValue);
  const [messages, disaptchMessage] = useReducer(messageReducer, message);
  return (
    <Formik
      enableReinitialize
      initialValues={state}
      validateOnMount
      validationSchema={schema(fields)}
      onSubmit={async (formData, { setSubmitting }) => {
        let url = "/brand/audience";
        let method = "POST";

        if (!!formData.ID) {
          url = "/brand/audience/" + formData.ID;
          method = "PUT";
        }

        let includeSegments = includedSegments.map((item) => item.segmentID);

        let validSegments = [];

        let data = objectFromFormData(state, memberDetails);

        async function getValidSegments() {
          await Promise.all(
            includeSegments.map(async (segmentId) => {
              try {
                const res = await axios({
                  url: "/segment/fields/" + segmentId,
                  disableRedirect: true,
                });

                if (res.status) {
                  const requiredKeys = res.data;
                  let validData = false;

                  data?.fields.forEach((obj) => {
                    if (requiredKeys.includes(Object.keys(obj)[0])) {
                      const val = obj[Object.keys(obj)[0]]?.value;
                      if (val !== null && val !== undefined && val !== "") {
                        validData = true;
                      }
                    }
                  });

                  if (validData) {
                    validSegments.push(segmentId);
                  }
                }
              } catch (error) {
                console.error(
                  "Error fetching segment fields for:",
                  segmentId,
                  error
                );
              }
            })
          );
        }

        await getValidSegments();

        axios({
          url: url,
          method: method,
          disableRedirect: true,
          data: {
            ...objectFromFormData(state, memberDetails),
            active_indexes: validSegments,
          },
        })
          .then((res) => {
            if (res.status) {
              if (!!formData.ID) {
                setEditState(false);

                let activeIndexes = [];
                let includedSegments = [];

                activeIndexes = res.data?.activeIndexes?.map((ind) =>
                  segments.findIndex((s) => s.id === ind)
                );

                includedSegments = segments
                  .filter((segment) =>
                    res.data?.activeIndexes?.includes(segment.id)
                  )
                  .map(({ id, segment_title }) => ({
                    segmentID: id,
                    segmentTitle: segment_title,
                  }));

                setActiveIndexes(activeIndexes);
                setIncludedSegments(includedSegments);

                dispatchUpdate(
                  alert({
                    message: "Audience updated successfully!",
                    type: "success",
                  })
                );
              } else {
                dispatchUpdate(
                  alert({
                    message: "Audience created successfully!",
                    type: "success",
                  })
                );
                navigate(pages.myCampaign.route);
              }
              setSubmitting(false);
            }
          })
          .catch((err) => {
            console.error(err);
          });
      }}
    >
      {(formikProps) => (
        <FormDisplay
          messages={messages}
          disaptchMessage={disaptchMessage}
          includedSegments={includedSegments}
          setIncludedSegments={setIncludedSegments}
          activeIndexes={activeIndexes}
          setActiveIndexes={setActiveIndexes}
          segments={segments}
          setFields={setFields}
          state={state}
          dispatch={dispatch}
          fields={fields}
          component={component}
          formikProps={formikProps}
          editState={editState}
          setEditState={setEditState}
        />
      )}
    </Formik>
  );
}

const messageReducer = (message, action) => {
  switch (action.type) {
    case "MESSAGE_UPDATE":
      var messageState = { ...message };
      if (Object.keys(action.payload.value).length === 0) {
        delete messageState[action.payload.key];
        return {
          ...messageState,
        };
      }

      return {
        ...message,
        ...action.payload.value,
      };

    default:
      return message;
  }
};
const formReducer = (state, action) => {
  switch (action.type) {
    case "UPDATE_FIELD":
      return {
        ...state,
        [action.payload.name]: {
          ...state[action?.payload?.name],
          [action.payload.key]: action.payload.value,
        },
      };

    case "MULTI_DROP_DOWN":
      var option = { ...state };

      if (action?.payload.value === undefined) {
        return {
          ...option,
        };
      }

      if (action.payload?.value?.length === 0) {
        delete option[action?.payload.name];
        return {
          ...option,
        };
      } else {
        return {
          ...state,
          [action.payload.name]: {
            ...state[action?.payload?.name],
            [action.payload.key]: action.payload.value,
          },
        };
      }

    case "DATE_UPDATE_FIELD":
      return {
        ...state,
        [action.payload.name]: {
          ...state[action?.payload?.name],
          [action.payload.key]: action.payload.value,
        },
      };

    case "RANGE_UPDATE":
      if (action.payload.noRange === "empty") {
        let updatedState = { ...state };
        delete updatedState[action?.payload?.name];
        return {
          ...updatedState,
        };
      }

      if (action.payload.value === undefined) {
        return {
          ...state,
        };
      }

      return {
        ...state,
        [action.payload.name]: {
          ...state[action?.payload?.name],
          value: {
            ...state[action?.payload?.name]?.value,
            [action.payload.key]: action.payload.value,
          },
        },
      };

    case "CALCULATE_PERCENTAGE":
      let value = action.payload.value;
      if (action.payload.value === "on" || action.payload.value === true) {
        value = true;
        state.mandatoryTrueCount = parseInt(state.mandatoryTrueCount) + 1;
      }

      if (action.payload.value === "off" || action.payload.value === false) {
        value = false;
        state.mandatoryTrueCount = parseInt(state.mandatoryTrueCount) - 1;
      }
      return {
        ...state,
        [action.payload.name]: {
          ...state[action?.payload?.name],
          [action.payload.key]: value,
        },
      };

    case "ADDITIONAL_FIELDS":
      return {
        ...state,
        [action.payload.name]: action.payload.value,
      };

    case "CHECKBOX":
      return {
        ...state,
        [action.payload.name]: action.payload.value,
      };

    case "UPDATE_NUMBER_FIELD":
      return {
        ...state,
        [action.payload.name]: {
          ...state[action?.payload?.name],
          [action.payload.key]: action.payload.value,
        },
      };

    case "DELETE_SEGMENT":
      return {
        ...action.payload.value,
      };

    default:
      return state;
  }
};
